import { NewMatchCardSchema } from '@/views/sports/components/NewMatchCard/styles/NewMatchCard.styles';

export const newMatchCardStyles: NewMatchCardSchema = {
  boxWrapper: {
    bg: 'white',
    borderRadius: 'md',
    boxShadow:
      '0 3px 5px rgba(0, 0, 0, .2), 0 1px rgba(255, 255, 255, .15) inset',
    overflow: 'hidden',
  },
  bodyStack: {
    p: '2',
    pb: '2.5',
    bg: 'white',
  },
  titleHeading: {
    cursor: 'pointer',
    as: 'h5',
    fontFamily: 'roboto',
    fontSize: 'sm',
    fontWeight: 'bold',
    color: 'gray.700',
  },
  footerFlex: {
    as: 'footer',
    bg: 'alpha.500',
    boxShadow: '0 -2px rgba(0, 0, 0, .15), 0 -1px rgba(255, 255, 255, .25)',
    fontSize: '2xs',
    fontWeight: 'semibold',
    px: '2',
    py: '1',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    alignItems: 'center',
    gap: '1',
  },
  footerStack: {
    direction: 'row',
  },
  footerStackDivider: {
    height: '2.5',
    borderColor: 'white',
  },
  footerSportNameFlex: {
    align: 'center',
    gap: '1',
    maxW: '85%',
    w: 'fit-content',
    mr: '1',
  },
  footerSportNameIconSvg: {
    color: 'beta.500',
    fontSize: 'sm',
  },
  footerCompetitionNameText: {
    sx: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      lineHeight: 'initial',
    },
  },
  footerCountDown: {
    pt: '0',

    sx: {
      '&&&.state-prior': {
        p: 0,
        lineHeight: 'initial',
        textTransform: 'uppercase',
        bg: 'none',
      },
    },
    sxWrapper: {
      mr: 'auto',
    },
  },
  footerDuotoneSgmLogo: {
    h: 'auto',
    primaryColor: 'alpha.500',
    secondaryColor: 'beta.600',
    w: '10',
  },
  footerMatchLink: {
    alignItems: 'center',
    display: 'flex',
    lineHeight: 'initial',
    fontSize: ['8px', null, '2xs'],
  },
  footerMatchLinkIcon: {
    color: 'beta.500',
    fontSize: 'xs',
  },
};
